import { decimalValue } from "../utils/regex";

export const validateDiscountOnChange = (name, value, preserveError) => {
   let errors = { ...preserveError };
   switch (name) {
      case "title":
         if (!value) {
            errors.title = "Please enter title";
         } else {
            delete errors.title
         }
         break;
      case "description":
         if (!value) {
            errors.description = "Please enter description";
         } else {
            delete errors.description
         }
         break;
      case "discount":
         if (!value) {
            errors.discount = "Please enter discount";
         } else if (!decimalValue.test(value)) {
            errors.discount = "Please enter valid amount";
         }
         else {
            delete errors.discount
         }
         break;
      case "max_discount":
         if (!value) {
            errors.discount = "Please enter max discount";
         } else if (!decimalValue.test(value)) {
            errors.discount = "Please enter valid amount";
         }
         else {
            delete errors.discount
         }
         break;

      default:
         break;
   }

   return errors;
};

export const validateDiscountSubmit = (discountData = {}) => {
   const {
      title,
      description,
      discount,
      max_discount,
   } = discountData

   const errors = {}

   if (!title) {
      errors.title = "Please enter title";
   }

   if (!description) {
      errors.description = "Please enter description";
   }

   if (!discount) {
      errors.discount = "Please enter discount";
   } else if (!decimalValue.test(discount)) {
      errors.discount = "Please enter valid amount";
   }

   if (!max_discount) {
      errors.max_discount = "Please enter max discount";
   } else if (!decimalValue.test(max_discount)) {
      errors.max_discount = "Please enter valid amount";
   }



   return errors
}
